module.exports = __webpack_public_path__ + "static/media/29DUNON15.f8f6c347.jpg";